<template>
  <div class="w-full">
    <!-- ****** ( model: settings_locked_pw ) ****** -->
    <div
      v-if="initiatedwith !== false"
      class="rounded relative bg-white w-full"
      :class="[
        validation_error ? 'border-red-500' : '',
        textarea && !engaged ? 'h-12' : '',
        !textarea ? 'h-12' : '',
        border_enabled ? 'shadow border border-truegray-300' : '',
        margin_bottom ? 'mb-10' : '',
      ]"
      @focus="handleFocus"
      @focusout="handleFocusOut"
    >
      <!-- Label -->
      <h6
        class="absolute transform duration-100 ease-linear px-1 left-3 top-1 z-20 text-truegray-700"
        :class="{ 'font-nunito': isContributor }"
        @click="engagement_locked ? (engaged = false) : (engaged = true)"
      >
        {{ label }}
      </h6>

      <!-- Input -->
      <input
        v-if="!textarea"
        :id="model_name"
        ref="textinput"
        v-model="inputvalue"
        :type="type"
        :class="[
          email_icon || search_icon ? 'pr-12' : '',
          validation_error ? 'text-red-500' : '',
          fixed_width ? 'w-full lg:w-48' : 'w-full',
          placeholder_black ? 'placeholder-black' : 'placeholder-truegray-300',
          isContributor ? 'font-nunito' : 'font-primary',
        ]"
        class="flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent h-12 text-black focus:placeholder-truegray-300"
        :name="model_name"
        autocomplete="off"
        :placeholder="placeholder_text"
        @keydown="checkMinMaxCharacters"
        @keyup="validateme"
      />

      <textarea
        v-if="textarea"
        :id="model_name"
        ref="textinput"
        v-model="inputvalue"
        type="text"
        :class="[
          email_icon ? 'pr-12' : '',
          validation_error ? 'text-red-500' : '',
          fixed_width ? 'w-full lg:w-58' : 'w-full',
          placeholder_black ? 'placeholder-black' : 'placeholder-truegray-300',
        ]"
        class="flex-grow px-4 mr-0 mt-5 outline-none focus:outline-none bg-transparent h-24 font-primary text-black focus:placeholder-truegray-300 transition-all duration-100 ease-in-out"
        :name="model_name"
        autocomplete="off"
        :placeholder="placeholder_text"
        rows="3"
        @click="engaged = !engaged"
        @keydown="checkMinMaxCharacters"
      >
      </textarea>

      <svg
        v-if="email_icon"
        xmlns="http://www.w3.org/2000/svg"
        :class="validation_error ? 'text-red-500' : ''"
        class="h-5 w-5 absolute right-3 bottom-1/2 transform translate-y-1/2 pointer-events-none bg-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
      <svg
        v-if="search_icon"
        xmlns="http://www.w3.org/2000/svg"
        :class="validation_error ? 'text-red-500' : ''"
        class="h-5 w-5 absolute right-3 bottom-1/2 transform translate-y-1/2 pointer-events-none bg-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="black"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>

    <p
      v-if="validation_error"
      class="flex justify-start items-center space-x-2 text-sm mt-2 text-red-500"
    >
      {{ validation_error }}
    </p>
  </div>
</template>

<script>
import { shared } from '../../js/mixins/shared.js'
import { EventBus } from '../../js/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
  mixins: [shared],

  props: {
    value: { default: false },
    label: { default: false },
    ui_model_name: { default: false },
    disabled: { default: false },
    placeholder: { default: 'Start typing...' },
    textarea: { default: false },
    ispassword: { default: false },
    type: { default: 'text' },
    load_engaged: { default: false },
    lock_engagement: { default: false },
    engage_focus: { default: true },
    border_enabled: { default: true },
    search_icon: { default: false },
    margin_bottom: { default: true },
    fixed_width: { default: false },
    placeholder_black: { default: false },
    // Callback storage input:
    callback_and_store: { default: false },
    // Min / Max characters:
    mincharacters: { type: Number, default: 0 },
    maxcharacters: { type: Number, default: 300 },
    response_selection_id: { default: false }, // @geoff this is a special response emitter... If detected will emit the option selected with the Emit name back to parents
  },

  data() {
    return {
      model_name: this.randomStrId(),
      inputvalue: '',
      inputdisabled: false,
      initiatedwith: false,
      engaged: false,
      placeholder_text: '',
      email_icon: false,
      validation_error: false,
      engagement_locked: false,
    }
  },

  computed: {
    ...mapGetters({
      isContributor: 'shared/isContributor',
    }),
  },

  watch: {
    value: {
      handler: function () {
        this.$set(this, 'inputvalue', this.value)
      },
    },

    placeholder: {
      handler: function () {
        if (this.engagement_locked) {
          return
        }
        this.$set(this, 'placeholder_text', this.placeholder)
      },
    },

    lock_engagement: {
      handler: function (val) {
        this.$set(this, 'engagement_locked', val)
      },

      deep: true,
    },

    engaged: {
      handler: function (val) {
        if (this.engagement_locked) {
          return
        }
        if (!val) {
          this.$set(this, 'placeholder_text', this.placeholder)
        } else {
          if (this.engage_focus) {
            this.$nextTick(() => this.$refs.textinput.focus()) // ... This element is presented after mount (and when the user engages with it! ) we therefore need to apply this in the next tick!
          }
          this.$set(this, 'placeholder_text', this.placeholder)
        }
      },

      deep: true,
    },

    inputvalue: {
      handler: function (val) {
        // Remove all spaces...
        if (!val) {
          // Remove all spaces...
          val = ''
          this.$set(this, 'inputvalue', val)
          this.$set(this, 'inputdisabled', true)
        } else {
          if (this.ispassword) {
            val = val.replace(' ', '')
          }
          this.$set(this, 'inputvalue', val)
          if (val.length < 6 || val === this.initiatedwith) {
            this.$set(this, 'inputdisabled', true)
          } else {
            this.$set(this, 'inputdisabled', false)
          }
        }

        // handle maximum characters/validation (after paste)
        if (this.inputvalue?.length > this.maxcharacters) {
          this.$set(
            this,
            'inputvalue',
            this.inputvalue.slice(0, this.maxcharacters),
          )
        }

        this.validateInput()
      },

      deep: true,
    },
  },

  mounted() {
    if (this.value) {
      this.$set(this, 'inputvalue', this.value)
      this.$set(this, 'initiatedwith', this.value)
    } else {
      this.$set(this, 'initiatedwith', '')
    }

    if (this.load_engaged && !this.lock_engagement) {
      this.$set(this, 'engaged', true)
    }

    if (this.lock_engagement) {
      this.$set(this, 'engagement_locked', true)
      this.$set(this, 'engaged', false)
    }

    if (this.value && !this.lock_engagement) {
      this.$set(this, 'engaged', true)
    }

    if (this.type) {
      switch (this.type) {
        case 'email':
          this.$set(this, 'email_icon', true)
          break
        default:
          break
      }
    }

    this.$set(this, 'engaged', true)
    if (this.disabled) {
      this.$set(this, 'inputdisabled', this.disabled)
    }
    if (this.ui_model_name) {
      this.$set(this, 'model_name', this.ui_model_name)
    }

    EventBus.$on('input_error_response', (data) => {
      if (!data.model_name) {
        return
      }
      if (data.model_name !== this.model_name) {
        return
      }
      data.message
        ? this.$set(this, 'validation_error', data.message)
        : this.$set(this, 'validation_error', false)
    })
  },

  methods: {
    validateme() {
      if (this.callback_and_store) {
        // Do we need to broadcast this back to the parent?
        // if (this.response_selection_id) {
        //     EventBus.$emit(this.response_selection_id,value);
        // }
      }
      // Do we need to broadcast this back to the parent?
      if (this.response_selection_id) {
        EventBus.$emit(this.response_selection_id, this.inputvalue)
      }
    },

    validateInput() {
      if (this.inputvalue?.length >= this.maxcharacters) {
        this.$set(
          this,
          'validation_error',
          'Max characters of ' + this.maxcharacters + ' reached.',
        )
        this.$set(this, 'inputdisabled', true)
      } else {
        this.$set(this, 'validation_error', false)
        this.$set(this, 'inputdisabled', false)
      }
    },

    checkMinMaxCharacters(evt) {
      if (
        this.inputvalue.length >= this.maxcharacters ||
        this.inputvalue.length < this.mincharacters
      ) {
        // prevent any more characters...
        if (evt) {
          if (evt.keyCode >= 48 && evt.keyCode <= 90 && evt.keyCode !== 32) {
            // 32 is a space and
            evt.preventDefault()
          }
          // prevent any spaces full stops and commas and
          if (
            evt.keyCode === 32 ||
            evt.keyCode === 16 ||
            (evt.keyCode >= 187 && evt.keyCode <= 192)
          ) {
            evt.preventDefault()
          }
        }
      }
    },

    handleFocus() {
      this.$set(this, 'engaged', true)
    },

    handleFocusOut() {
      if (this.inputvalue.length > 0) {
        // ...
      } else {
        this.$set(this, 'engaged', false)
      }
    },
  },
}
</script>
